import { render, staticRenderFns } from "./ChangeConversationStatusModal.vue?vue&type=template&id=b2fa5e96&"
import script from "./change-conversation-status-modal.ts?vue&type=script&lang=ts&"
export * from "./change-conversation-status-modal.ts?vue&type=script&lang=ts&"
import style0 from "./ChangeConversationStatusModal.vue?vue&type=style&index=0&id=b2fa5e96&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports